import React, { PropTypes } from 'react'
import { browserHistory } from 'react-router'
import { storage } from '../utils'

function redirectToSignOut() {
    browserHistory.push('/sign-out')
}

export default function Header({ title }) {
    return (
        <div className="header">
            <div className="header__container">
                { title.toUpperCase() || 'Title' }
            </div>
            <div className="header__links">
                { storage.getItem('impersonationToken') &&
                    <div className="header-link tablet-only" onClick={ redirectToSignOut }>
                        <i className="fa fa-user" style={{ color: '#d60000' }} />
                        &nbsp;&nbsp;Stop impersonating
                    </div>
                }
                <div className="header-link header__sign-out" onClick={ redirectToSignOut }>
                    <span className="header__sign-out-text">Sign out</span>
                </div>
            </div>
        </div>
    )
}

Header.propTypes = {
    title: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./app/components/header.js